import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface CCModalData {
  ccChartData:     number[];
  ccScore:         number;
  ccSubtitle:      string;
  ccTop3:          Array<{ name: string; score: string }>;
  ccBottom3:       Array<{ name: string; score: string }>;
  ccVerification:  string;
  creChartData:    number[];
  creScore:        number;
  creProgress:     { closed: number; open: number; overdue: number };
  creStats:        Array<{ value: number; label: string }>;
  overdueFindings: Array<{ date: string; location: string; level: number; dateColor: string; findingNumber?: string }>;
  creTableData?:   any[];
  aiText:          string;
}

@Injectable({ providedIn: "root" })
export class CCModalService {
  isOpen$    = new BehaviorSubject<boolean>(false);
  modalData$ = new BehaviorSubject<CCModalData | null>(null);

  setData(data: CCModalData): void {
    this.modalData$.next(data);
  }

  open(): void {
    this.isOpen$.next(true);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.setProperty("--overflow", "hidden");
  }

  close(): void {
    this.isOpen$.next(false);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.removeProperty("--overflow");
  }
}
